<template>
    <div>
        <!-- 查询 -->
        <div class="searchPanel">
            <SearchForm 
                :class="{queryForm_en:lang == 'en', queryForm_zh:lang == 'zh'}" 
                :form="queryForm"
                @handleInputChange="handleInputChange"
                @handleSelectChange="handleQuerySelectChange"
                @handlePressEnter="handleQueryPressEnter"
            ></SearchForm>
        </div>

        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <!-- 表头自定义按钮 -->
            <template v-slot:operateBtn>
                <a-button type="primary" size="small" class="operate_btn" @click="handle('add')">
                    <component :is="$antIcons['PlusOutlined']"></component>
                    {{$t('base.add')}}
                </a-button>
            </template>
            
            <!-- 表格列自定义列内容 -->
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'status'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.status_val === 0 ? 'green' : 'red'"
                        >{{ props.record.status }}</a-tag>
                    </div>
                </template>
            </template>

            <!-- 表格操作按钮 -->
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="link" size="small" :disabled="props.record.status_val == 1" style="margin-right:10px" @click="handle('stop',props.record)">
                        {{$t('notice.cancel')}}
                    </a-button>
                    <a-button type="link" size="small" style="margin-right:10px" @click="handle('detail',props.record)">
                        {{$t('notice.detail')}}
                    </a-button>
                </template>
            </template>
        </Table>

        <!-- 详情 -->
        <a-drawer
            :width="900"
            title="公告详情"
            :placement="placement"
            :visible="detailVisible"
            @close="detailVisible = false"
        >
            <div class="detail_item">
                <span class="label">{{ $t('notice.relateApp') }} ：</span> 
                <span class="value">{{ detail.app_name }}</span> 
            </div>
            <div class="detail_item">
                <span class="label">{{ $t('notice.notice_title2') }}： </span> 
                <span class="value">{{ detail.notice_title }}</span> 
            </div>
            <div class="detail_item">
                <span class="label">{{ $t('notice.content') }}：</span> 
                <div class="value" v-html="detail.notice_content"></div>
            </div>
        </a-drawer>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch } from "vue";
    import Table from "@/components/Table.vue";
    import SearchForm from "@/components/Form.vue";
    import { useRouter } from "vue-router";
    import { QueryForm } from './js/formConfig.js';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
    import { NoticeApi } from '@/api/NoticeApi.js';
    import { debounce } from 'lodash-es';

    const { t } = useI18n()
    const router = useRouter()

    const userInfo = ref(JSON.parse(localStorage.getItem('hd_ota_loginUser')))
    const queryForm = reactive(QueryForm)
    const detailVisible = ref(false)
    const detail = ref(null)
    const table = ref({
        data: [],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('notice.relateApp'),//'标题'
                dataIndex: 'app_name',
                key: 'app_name',
                width: 100,
                resizable: true,
                locel:'notice.app_name',
            },
            {
                title: t('notice.notice_title'),//'标题'
                dataIndex: 'notice_title',
                key: 'notice_title',
                width: 200,
                resizable: true,
                ellipsis :true,
                locel:'notice.notice_title',
            },
            {
                title: t('notice.status'),//'状态'
                dataIndex: 'status',
                key: 'status',
                width: 100,
                resizable: true,
                locel:'notice.status',
            },
            {
                title: t('notice.customer_name'),
                dataIndex: 'customer_name',
                key: 'customer_name',
                width: 100,
                resizable: true,
                locel:'notice.customer_name',
            },
            {
                title: t('notice.manufacturer_name'),
                dataIndex: 'manufacturer_name',
                key: 'manufacturer_name',
                width: 100,
                resizable: true,
                locel:'notice.manufacturer_name ',
            },
            {
                title: t('notice.model_name'),
                dataIndex: 'model_name',
                key: 'model_name',
                width: 100,
                resizable: true,
                locel:'notice.model_name',
            },
            {
                title: t('notice.hardware_platform_name'),
                dataIndex: 'hardware_platform_name',
                key: 'hardware_platform_name',
                width: 100,
                resizable: true,
                locel:'notice.hardware_platform_name',
            },
            {
                title: t('notice.create_time'),//'创建日期'
                dataIndex: 'create_time',
                key: 'create_time',
                width: 120,
                resizable: true,
                locel:'notice.create_time',
            },
            {
                title: t('notice.cancel_time'),//'取消日期'
                dataIndex: 'cancel_time',
                key: 'cancel_time',
                width: 120,
                resizable: true,
                locel:'notice.cancel_time',
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 130,
                resizable: true,
            },
        ],
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })


    const handleInputChange = debounce((val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }, 1000)

    const handleQueryPressEnter = (val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    const handleQuerySelectChange = (val, key)=>{
        console.log(val,'sssss')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    // 分页
    function handleChangePagination(config, data) {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const handle = (type, row)=>{
        switch(type){
            case 'add':
                router.push({path:'/Notice/Add'})
                break;
            case 'stop': // 取消
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认取消该公告?',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        cancelNotice(row)
                    },
                });
                break;
            case 'detail': // 详情
                detailVisible.value = true
                detail.value = row
                break;
        }
    }


    // 获取公告列表
    const getList = async () => {
        let param = {
            ...queryForm.formData,
            app_id: userInfo.value.app_id,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await NoticeApi.getInstance().getNoticeList(param, page_num, page_size)
        if (res.code == 0) {
            let data = res.data
            data.records.forEach((i, index) => {
                i.serial = index + 1
                i.status_val = i.status == undefined? '-' : i.status
                i.status = i.status == 0? t('base.normal') : t('base.canceled')
                i.customer_name = i.customer_name == undefined? '-' : i.customer_name
                i.hardware_platform_name = i.hardware_platform_name == undefined? '-' : i.hardware_platform_name
                i.manufacturer_name = i.manufacturer_name == undefined? '-' : i.manufacturer_name
                i.model_name = i.model_name == undefined? '-' : i.model_name
                i.cancel_time = i.cancel_time == undefined? '-' : i.cancel_time
            })
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            console.log(table.value.data,'table.value.data')

            table.value.configs.loading = false
        } else {
            message.error(res.msg);
        }
    }

    // 取消公告
    const cancelNotice = async (row)=>{
        let param = {
            id: row.id,
        }
        let res = await NoticeApi.getInstance().cancelNotice(param, row.id)
        if (res.code == 0) {
            status == 0? message.success('已启用') :  message.success('已禁用') 
            table.value.configs.pagination.current = 1
            getList()
        } else {
            message.error(res.msg);
        }
    }

    onMounted(()=>{
        getList()
    })

</script>

<style lang="scss" scoped>
.searchPanel{
    margin-bottom: 5px;
    background: #fff;
    border-bottom: 1px dashed #ddd;

    ::v-deep .ant-form-item{
        margin-bottom: 4px;
    }
}

.detail_item{
    padding: 10px 0;
    .label{
        font-size:14px;
        font-weight: 600;
    }

    .value{
        color: #666;
    }
}


::v-deep .ant-table tfoot>tr>td, 
::v-deep .ant-table tfoot>tr>th, 
::v-deep .ant-table-tbody>tr>td, 
::v-deep .ant-table-thead>tr>th {
    overflow-wrap: break-word;
    padding: 14px;
    position: relative;
}
</style>